<div class="internal" id="main">
  <div class="section select-user" id="select-user">
    <div class="content-body">
      <div class="content">
        @if (!noBookableSlots) { @if (!autologin) {
        <div class="content-header clickable" (click)="Back()">
          <button class="costa-button back">
            <img src="../../../assets/images/back.svg" alt="Back button" />
          </button>
          <div class="step">
            {{ "stepper.step" | translate }} <b>1</b>
            {{ "stepper.of" | translate }} 3
          </div>
        </div>
        } @else {
        <div class="content-header">
          <div class="step">
            {{ "stepper.step" | translate }} <b>1</b>
            {{ "stepper.of" | translate }} 3
          </div>
        </div>
        }
        <div class="subtitle">
          <p>{{ "select_user.subtitle" | translate }}</p>
        </div>
        <ul class="cards">
          @for (el of datasource; track el.uuid_passenger) { @if
          (el.companion_type === 'CABIN_BNO') {
          <li
            class="card user"
            (click)="Select(el)"
            [ngClass]="{
              selected:
                el.selected && el.attribute != 'passenger.attribute.you',
              disabled: el.attribute == 'passenger.attribute.you',
              you: el.attribute == 'passenger.attribute.you'
            }"
          >
            <div class="wrap-name">
              <div class="iniziali">
                <div class="user-name">{{ el.inizialiNome }}</div>
                <div class="circle"></div>
              </div>
              <h3 class="card-title">
                {{ el.name!.toLocaleLowerCase() }}
                {{ el.surname!.toLocaleLowerCase() }}
                @if (el.attribute) { ({{ el.attribute | translate }}) }
              </h3>
            </div>
            <label class="form-control-checkbox">
              <input type="checkbox" *ngIf="!el.selected" title="Select user" />
              <input
                type="checkbox"
                *ngIf="el.selected"
                title="Selected user"
                checked
              />
              <span
                class="checkmark"
                [ngClass]="{
                  you: el.attribute == 'passenger.attribute.you'
                }"
              ></span>
            </label>
          </li>
          } }
        </ul>
        @if (diningWith) {
        <div class="subtitle" style="margin-top: 32px">
          <p>{{ "select_user.subtitle_companions" | translate }}</p>
        </div>
        <ul class="cards">
          @for (el of datasource; track el.uuid_passenger) { @if
          (el.companion_type === 'DINING_WITH') {
          <li
            class="card user"
            (click)="Select(el)"
            [ngClass]="{ selected: el.selected }"
          >
            <div class="wrap-name">
              <div class="iniziali">
                <div class="user-name">{{ el.inizialiNome }}</div>
                <div class="circle"></div>
              </div>
              <h3 class="card-title">
                {{ el.name!.toLocaleLowerCase() }}
                {{ el.surname!.toLocaleLowerCase() }}
                @if (el.attribute) { ({{ el.attribute | translate }}) }
              </h3>
            </div>
            <label class="form-control-checkbox">
              <input type="checkbox" title="Select user" *ngIf="!el.selected" />
              <input
                type="checkbox"
                title="Selected user"
                *ngIf="el.selected"
                checked
              />
              <span class="checkmark"></span>
            </label>
          </li>
          } }
        </ul>
        } } @else {
        <div class="message no-user">
          <div class="icon">
            <img src="../../../assets/images/Info.svg" alt="Info icon" />
          </div>
          <div style="white-space: pre-line">
            <p class="text">
              {{
                "select_user.message"
                  | translate
                    : {
                        phone_number: phone_number
                      }
              }}
            </p>
          </div>
        </div>
        }
      </div>
      @if (!noBookableSlots) {
      <div class="buttons">
        <button
          (click)="Proceed()"
          [disabled]="this.selectedCompanions.length == 0"
          class="costa-button"
          type="button"
        >
          {{ "proceed" | translate }}
        </button>
      </div>
      } @else {
      <div class="buttons">
        <button class="costa-button" type="button" (click)="Close()">
          {{ "close" | translate }}
        </button>
      </div>
      }
    </div>
  </div>
</div>
